import { render, staticRenderFns } from "./LivingOptionsDwellings.vue?vue&type=template&id=32a2cbee"
import script from "./LivingOptionsDwellings.vue?vue&type=script&lang=js"
export * from "./LivingOptionsDwellings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports